import React from 'react';
import './App.css';
import LocationTracker from './LocationTracker';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Location Tracker</h1>
        <LocationTracker />
      </header>
    </div>
  );
}

export default App;
